<template>
  <div class="account-index">
    <div class="title">
      <span>账户列表</span>
      <mu-button
        class="add-btn"
        color="purple"
        @click="addOpen = true"
        v-if="user.role.name === '管理员'"
      >
        <mu-icon value="add" :size="20"></mu-icon>
        新增账户
      </mu-button>
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <mu-form-item prop="search" label="搜索" label-position="left">
        <mu-text-field
          v-model="form.keyword"
          help-text="请输入搜索内容"
        ></mu-text-field>
      </mu-form-item>
      <mu-form-item>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </mu-form-item>
    </mu-form>
    <div class="analysis">
      <mu-button fab color="indigo" large>
        {{ (Number(contribute) + Number(sum)).toFixed(2) }}
      </mu-button>
    </div>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>{{ scope.row.name }}</td>
          <td>{{ scope.row.user.realName }}</td>
          <td>{{ scope.row.money }}</td>
          <td>{{ scope.row.remark }}</td>
          <td>
            <mu-button
              color="info"
              @click="edit(scope.row)"
              v-if="user.role.name === '管理员'"
            >
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button
              color="secondary"
              @click="deleteOne(scope.row)"
              v-if="user.role.name === '管理员'"
            >
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td>
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import backend from 'utils/backend'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: { Create, Update },
  data() {
    return {
      loading: false,
      addOpen: false,
      editOpen: false,
      editForm: {},
      form: {
        keyword: '',
        page: 1,
        relations: ['account.user']
      },
      total: 1,
      columns: [
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '账户所属人',
          name: 'user',
          align: 'center'
        },
        {
          title: '金额',
          name: 'money',
          align: 'center'
        },
        {
          title: '备注',
          name: 'remark',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          width: 400
        }
      ],
      list: [],
      sum: 0,
      contribute: 0
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.account.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      this.sum = 0
      backend(api.account.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
          result.data.rows.forEach((item) => {
            this.sum += Number(item.money)
          })
        }
      })
    },
    getAllContribute() {
      backend(api.contribute.getAll, { getAll: true }).then((result) => {
        if (result.statusCode === 200) {
          let contribute = 0
          result.data.rows.forEach((item) => {
            contribute += Number(item.money)
          })
          this.contribute = contribute
        }
      })
    }
  },
  mounted() {
    this.getAll()
    this.getAllContribute()
  },
  computed: {
    ...mapGetters(['user'])
  }
}
</script>

<style lang="less" scoped>
.account-index {
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .analysis {
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .table {
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account/index.vue